import { queryTypes, useQueryState } from 'next-usequerystate';
import { useEffect, useState } from 'react';

type UseSyncQueryParamsOptions = {
  key: string;
  defaultValue?: string;
};

type UseSyncQueryParamsState = {
  tab: string | undefined;
};

type UseSyncQueryParamsActions = {
  onTabChange: (value: string) => void;
};

export type UseSyncQueryParamsValue = UseSyncQueryParamsState &
  UseSyncQueryParamsActions;

const useSyncQueryParams = (
  props: UseSyncQueryParamsOptions
): UseSyncQueryParamsValue => {
  const [tabQuery, setTabQuery] = useQueryState(
    props.key,
    props.defaultValue
      ? queryTypes.string.withDefault(props.defaultValue)
      : queryTypes.string
  );

  const [currentTab, setCurrentTab] = useState(props.defaultValue);

  // note: this won't work without the useEffect
  useEffect(() => {
    if (tabQuery !== currentTab && tabQuery !== null) {
      setCurrentTab(tabQuery);
    }
  }, [currentTab, tabQuery]);

  const onTabChange = (value: string) => {
    setCurrentTab(value);

    setTabQuery(value, {
      scroll: false,
      shallow: true,
    });
  };

  return {
    tab: currentTab,
    onTabChange,
  };
};

export default useSyncQueryParams;
